import moment from "moment";
import { PRIMARY_TEXT_COLOR } from "../../color";
import CustomDataTable from "../../Components/CustomDataTable";
import { genareteColor } from "../../Helper/GenerateStatusColor";

const Payment = () => {
  const columnDefs = [
    {
      field: "fld_name",
      header: "Payment Id",
      sortable: true,
      headerStyle: { width: "200px", minWidth: "200px", fontSize: "13px" },
      bodyStyle: { minWidth: "200px", fontSize: "13px" },
    },
    {
      field: "fld_credit",
      header: "Request Type",
      sortable: true,
      headerStyle: { width: "200px", minWidth: "200px", fontSize: "13px" },
      bodyStyle: { minWidth: "200px", fontSize: "13px" },
    },
    {
      field: "fld_credit",
      header: "Payment Mode",
      sortable: true,
      headerStyle: { width: "200px", minWidth: "200px", fontSize: "13px" },
      bodyStyle: { minWidth: "200px", fontSize: "13px" },
    },
    {
      field: "fld_credit",
      header: "Received Amount",
      sortable: true,
      headerStyle: { width: "200px", minWidth: "200px", fontSize: "13px" },
      bodyStyle: { minWidth: "200px", fontSize: "13px" },
    },
    {
      field: "fld_createdAt",
      header: "Added on",
      sortable: true,
      body: (rowData) =>
        moment(rowData?.fld_createdAt).format("DD MMM YYYY") || "",
      headerStyle: { width: "250px", fontSize: "13px" },
      bodyStyle: { minWidth: "250px", fontSize: "13px" },
    },
    {
      field: "fld_status",
      header: "Status",
      sortable: true,
      width: "100px",
      body: (rowData) => (
        <span
          className={`${genareteColor(
            rowData.fld_status
          )} font-size-3 rounded-3 px-2`}
        >
          {rowData.fld_status}
        </span>
      ),
      headerStyle: { width: "100px", fontSize: "13px" },
      bodyStyle: { minWidth: "100px", fontSize: "13px" },
    },
  ];
  return (
    <div>
      <div className="d-flex justify-content-between align-items-center flex-wrap mt-4">
        <h5 style={{ color: PRIMARY_TEXT_COLOR }}>Transaction History</h5>
      </div>
      <div className="mt-2" style={{ minHeight: "400px" }}>
        <CustomDataTable
          data={[
            {
              id: 1,
              fld_name: "John Doe",
              fld_credit: 500,
              fld_createdAt: "2024-02-10T10:00:00",
              fld_status: "Active",
            },
          ]}
          columns={columnDefs}
          compact={true} // Enables compact styling
        />
      </div>
    </div>
  );
};

export default Payment;
